import { render, staticRenderFns } from "./SelectResolutionTextDlg.vue?vue&type=template&id=19a55948&"
import script from "./SelectResolutionTextDlg.vue?vue&type=script&lang=js&"
export * from "./SelectResolutionTextDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports